import React from 'react';
import { Link } from 'gatsby-theme-material-ui';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';

import styles from './dsStyles';
import { SuitcaseIcon } from '../../../kit/icons/SuitcaseIcon';
import { useCareerQuery } from '../../../app/queries/career.query';

import Section from '../../../shared/Section/Section';

function DsEmploymentsShortDescription({ data }) {
  const { careerImgs } = useCareerQuery();
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Section
      wrapperStyles={{ height: { xs: 413, sm: 'auto', lg: 413 } }}
      withoutBg
    >
      {isSm ? (
        <Grid container spacing={2}>
          <Grid item container xs={12} md={12}>
            <Grid item xs={12}>
              <Typography
                variant="desktopH2"
                color="kit.text.main"
                sx={{
                  whiteSpace: 'break-spaces',
                }}
              >
                {data.title}
              </Typography>
            </Grid>
            <Grid item container xs={6} alignSelf="flex-end">
              <Grid item xs={12}></Grid>
            </Grid>
            <Grid item xs={12} sx={{ width: '100%', mt: 2 }}>
              <Box sx={styles.image}>
                <GatsbyImage
                  image={getImage(
                    careerImgs['career/ds_employment_short_description_mobile'],
                  )}
                  alt="reason_of_study"
                  loading="lazy"
                />
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} mt="-24px">
            <SuitcaseIcon size="24" />

            <Typography variant="mobileP2" color="kit.text.main" mt="8px">
              {data.markedSubTitle}
            </Typography>
            <Box mt={'12px'}>
              <Link
                target="_blank"
                to="/career"
                variant="kitPrimary"
                typography="mobileP2"
                sx={{
                  fontSize: {
                    xs: 16,
                    md: 16,
                  },
                }}
              >
                О трудоустройстве выпускников
              </Link>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={5.3}>
            <Grid item xs={7}>
              <Typography
                variant="desktopH2"
                color="kit.text.main"
                sx={{
                  whiteSpace: 'pre-line',
                  marginBottom: '48px',
                }}
              >
                {data.title}
              </Typography>
            </Grid>
            <Grid item xs={12} mt="48px" mb="12px">
              <SuitcaseIcon />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="desktopP1" color="kit.text.main">
                {data.markedSubTitle}
              </Typography>
              <Box mt="12px">
                <Link
                  target="_blank"
                  to="/career"
                  variant="kitPrimary"
                  typography="desktopP2"
                  sx={{
                    fontSize: {
                      xs: 14,
                      md: 16,
                    },
                  }}
                >
                  О трудоустройстве выпускников
                </Link>
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={6.5}>
            <Box sx={styles.image}>
              <GatsbyImage
                image={getImage(
                  careerImgs['career/ds_employment_short_description'],
                )}
                alt="reason_of_study"
                loading="lazy"
              />
            </Box>
          </Grid>
        </Grid>
      )}
    </Section>
  );
}

export default DsEmploymentsShortDescription;
